import {createSlice, PayloadAction} from '@reduxjs/toolkit';

type CustomerAdminState = {
    customerTabs: CustomerTab[];
    currentTab: string;
};

type CustomerTab = {
    key: string;
    display: string;
};

const baseSessionState = {
    customerTabs: [],
    currentTab: 'search',
} as CustomerAdminState;

const slice = createSlice({
    name: 'customerAdmin',
    initialState: baseSessionState,
    reducers: {
        addCustomerTab: (state, action: PayloadAction<CustomerTab>) => {
            state.customerTabs.push(action.payload);
        },
        removeCustomerTab: (state, action) => {
            state.customerTabs = state.customerTabs.filter(
                (x) => x.key !== action.payload
            );
        },
        setCurrentTab: (state, action: PayloadAction<string>) => {
            state.currentTab = action.payload;
        },
    },
});

export const {addCustomerTab, removeCustomerTab, setCurrentTab} = slice.actions;

export default slice.reducer;
